import './HeroButtons.scss';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

class HeroButtons {

  constructor(node) {
    this.node = node;
    this.isGsapEnabled = window.innerWidth >= 991;
  }

  init() {
    gsap.registerPlugin(ScrollTrigger)

    const labels = document.querySelectorAll('.HeroButtons .label-item')
    const mouse = document.querySelector('.mouse');

    labels.forEach((label, index) => {
      gsap.fromTo(label, 
        { opacity: 0, x: "-20%", },
        {
          opacity: 1,
          x: "0%",
          duration: 0.5,
          delay: index * 0.1,
          ease: "power2.inOut",
          onComplete: () => gsap.set(label, { opacity: 1 }) 
        }
      );
    });

    if (!this.isGsapEnabled) return;

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".HeroButtons",
        start: "top -20%",
        end: "bottom -20%",
        scrub: 1, 
        effects: true,
      },
    });

    tl
      .to('.HeroButtons', {duration: 2, paddingBottom: '20%', marginBottom: '-40%', "--clip": '0%',  ease: 'linear'})
      labels.forEach((label, index) => {
        tl.to(label, { opacity: 0, x: "20%", delay: index * 0.1 }, "<");
      });

      mouse.addEventListener('click', () => {
        const heroButtons = document.querySelector('.HeroButtons');

        window.scrollTo({
          top: heroButtons.offsetHeight / 2 + heroButtons.offsetHeight * 0.21 ,
          behavior: 'smooth'
        });
      });
    }

}

JSModules['HeroButtons'] = HeroButtons;
export default HeroButtons;
